import { writable, get } from "svelte/store";
import { emptyQuestions, changeQuestionsLang } from "./questions";

const storedQuestionsJson = sessionStorage.getItem("questions");
const storedQuestions = storedQuestionsJson ? JSON.parse(storedQuestionsJson) : null;

const storedCraftJson = localStorage.getItem("craft");
const storedCraft = storedCraftJson ? JSON.parse(storedCraftJson) : null;

const storedLangJson = localStorage.getItem("lang");
const storedLang = storedLangJson ? JSON.parse(storedLangJson) : "fi";

export const isReady = writable(false);
export const questions = writable(storedQuestions || [ ...emptyQuestions ]);
export const craft = writable(storedCraft);
export const readOnly = writable(false);
export const questionType = writable("normal");
export const lang = writable(storedLang);

questions.subscribe(value => { sessionStorage.setItem("questions", JSON.stringify(value)) });
craft.subscribe(value => { if(value !== null) localStorage.setItem("craft", JSON.stringify(value)) });
lang.subscribe(value => { 
    if(value !== null) {
        localStorage.setItem("lang", JSON.stringify(value));

        let currentQuestions = [ ...get(questions) ];

        if(value === "fi") {
            const questions_fi = changeQuestionsLang(currentQuestions, "fi");
            questions.set(questions_fi);
        }
        else if(value === "en") {
            const questions_en = changeQuestionsLang(currentQuestions, "en");
            questions.set(questions_en);
        }
    }
});

